const getSalesTabsActions = (tabsIndex: string) => {
  return {
    type: "GET_TABS_SALES",
    payload: tabsIndex,
  };
};

export { getSalesTabsActions };
